import * as React from "react";
import { useState, useEffect, useContext } from "react";
import {
  DataGrid,
  deDE,
} from "@mui/x-data-grid";
import { Container, Row, Col } from "reactstrap";

import {
  TextField,
  InputAdornment,
  Paper,
  FormControlLabel,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Switch
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate, useLocation } from "react-router-dom";
import CustomerSearchDialog from "./CustomerSearchDialog";
import {
  QueryClient,
  QueryClientProvider,
} from "react-query";
// using node-style package resolution in a CSS file:
import "./MainPage.css";
import { getUserToken } from "../utils/AuthTokenReader.jsx";
import BAVButton from "./BAVButton";
import { debugLog } from "../utils/Util";
import { Snackbar, Alert } from "@mui/material";


const queryClient = new QueryClient();

export default function MainPage() {
  return (
    <QueryClientProvider client={queryClient}>
      <CreateMainPage />
    </QueryClientProvider>
  );
}

function CreateMainPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [options, setOptions] = useState();
  const [token, setToken] = useState();
  const initToken = async () => {
      try {
          const ltoken = await getUserToken();
          setToken(ltoken);
          const headers = new Headers();
          const bearer = `Bearer ${ltoken.accessToken}`;
          headers.append("Authorization", bearer);
          headers.append("Content-Type", "application/json");
          setOptions({ headers: headers });
      } catch (err) {

          showNotification(
              "Anmeldung fehlgeschlagen. Bitte neu anmelden.",
              "error"
          );

      }
  };

  const reInitToken = new Promise((resolve, reject) => {
    if (token && token.expiresOn < Date.now()) {
        debugLog('Start initToken');
        initToken()
            .then((res) => {
                debugLog('Finished initToken');
                resolve('initToken');
             })
     } else {
        debugLog('tokenValid');
        resolve('tokenValid');
     }
  });

  const initializeSearchCriteria = () => {
    return JSON.parse(localStorage.getItem("searchCriteria")) ?? "";
  };

  const initializeSearchData = () => {
    return JSON.parse(localStorage.getItem("searchData")) ?? [];
  };
  const initializeAdivsorData = () => {
    return JSON.parse(localStorage.getItem("adivsorData")) ?? [];
    };

  const [notification, setNotification] = useState({
        open: false,
        severity: "info", // info | success | warning | error
        message: ""
   });


  function clearStorage() {
    let session = sessionStorage.getItem("register");
    if (session == null) {
      localStorage.removeItem("searchCriteria");
      localStorage.removeItem("searchData");
      localStorage.removeItem("advisorData");
      setCustomerdata([]);
      setSearchCriteria("");
    }
    sessionStorage.setItem("register", 1);
    }

  function showNotification(message, severity = "info") {
        setNotification({
            open: true,
            severity,
            message
        });
  }


  const [kundendaten, setCustomerdata] = useState(initializeSearchData());
  const [loading, setLoading] = useState(false);
  const [searchCriteria, setSearchCriteria] = useState(
    initializeSearchCriteria()
  );
  const [advisordata, setAdvisordata] = useState(initializeAdivsorData());
  const [selectedAdvisor, setSelectedAdvisor] = useState("");
  const [onlyActive, setOnlyActive] = useState(1);

  useEffect(() => {
    initToken();
  }, []);
  useEffect(() => {
    clearStorage();
    if (options) {
      const getAdvisorData = async () => {
          await reInitToken;
          const res = await fetch("/advisors", options);
          const response = await res.json();
        setAdvisordata(response);
      };
      getAdvisorData();
      // Wenn reload Flag gesetzt, dann Kunden  neu lesen
      if(location.state &&  location.state.reload){
        location.state.reload = 0;
        readCustomerData(searchCriteria, selectedAdvisor, onlyActive);
      }
    }
  }, [options]);

  useEffect(() => {
    localStorage.setItem("searchCriteria", JSON.stringify(searchCriteria));
  }, [searchCriteria]);

  useEffect(() => {
    localStorage.setItem("searchData", JSON.stringify(kundendaten));
  }, [kundendaten]);

  useEffect(() => {
    localStorage.setItem("advisorData", JSON.stringify(advisordata));
  }, [advisordata]);

  function readCustomerData(searchCriteria, selectedAdvisor, active) {
      var kdlnr = "";
      if (selectedAdvisor) {
        for (var i = 0; i < advisordata.length; i++) {
          if (advisordata[i].benutzer == selectedAdvisor) {
            kdlnr = advisordata[i].kdLnr;
            break;
          }
        }
      }
      setLoading(true);
      // Wenn nur eigene, dann noch eigene KundenLnr mitgeben own=214234234
      var act = active?1:0;
      kdlnr = kdlnr ? "?kdlnrberat=" + kdlnr +"&active="+act : "?active=" + act;
      var path = searchCriteria
        ? "/customers/search/" + searchCriteria + kdlnr
        : "/customers" + kdlnr ;
      reInitToken
          .then((res) => {
              return fetch(path, options)
                  .then(async (res) => {
                      if (!res.ok) {
                          const text = await res.text();
                          throw new Error(`HTTP ${res.status}: ${text}`);
                      }
                      return res.json();
                  })
                  .then((data) => {
                      setCustomerdata(data);
                      setLoading(false);
                  })
                  .catch((error) => {

                      setLoading(false);

                      if (error.message.includes("401") || error.message.includes("403")) {
                          showNotification(
                              "Sitzung abgelaufen. Bitte neu anmelden.",
                              "warning"
                          );
                      } else {
                          showNotification(
                              "Kundendaten konnten nicht geladen werden. Versuchen Sie sich neu anzumelden",
                              "error"
                          );
                      }

                  })
          });
    }


  function clickSearch() {
    readCustomerData(searchCriteria, selectedAdvisor, onlyActive);
  }

  function handleRowDoubleClick(params, me, det) {

    var kd = params.row;
    navigate("/customerDetail", { state: { kunde: kd } });
  }

  function handleOwnCustomers(e) {
    setOwnCustomerOnly(e.target.checked);
  }
  function handleClearClick(e) {}

  function handleSwitchActive(e) {
      setOnlyActive(e.target.checked);
  }

  const searchButton = (
    <BAVButton variant="contained" onClick={clickSearch}>
      Suchen
    </BAVButton>
  );

  const searchFieldProps = {
    endAdornment: (
      <InputAdornment position="end">
        <SearchIcon />
      </InputAdornment>
    ),
  };
  const columns = [
    {
      field: "kdNr",
      headerName: "Kunden-Nr",
      headerClassName: "BAVColumnHeader",
      width: 120,
    },
    {
      field: "surname",
      headerName: "Vorname",
      headerClassName: "BAVColumnHeader",
      width: 110,
    },
    {
      field: "name",
      headerName: "Name",
      headerClassName: "BAVColumnHeader",
      width: 180,
    },
    {
      field: "city",
      headerName: "Ort",
      headerClassName: "BAVColumnHeader",
      width: 130,
    },
    {
      field: "birthdate",
      headerName: "Geb.-Datum",
      headerClassName: "BAVColumnHeader",
      width: 120,
      valueFormatter: ({ value }) =>
        value &&
        new Date(value).toLocaleString("de-CH", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        }),
    },
    {
      field: "createDate",
      headerName: "Erstellt",
      headerClassName: "BAVColumnHeader",
      width: 140,
      valueFormatter: ({ value }) => value && new Date(value).toLocaleString(),
    },
    {
      field: "createdBy",
      headerName: "Erstellt von",
      headerClassName: "BAVColumnHeader",
      width: 160,
    },
    {
      field: "changeDate",
      headerName: "Geändert",
      headerClassName: "BAVColumnHeader",
      width: 140,
      valueFormatter: ({ value }) => value && new Date(value).toLocaleString(),
    },
    {
      field: "changedBy",
      headerName: "Geändert von",
      headerClassName: "BAVColumnHeader",
      width: 140,
      },
    {
        field: "kundenHauptTypCode",
        headerName: ""
    }
  ];

  return (
    <>
      <Container className="mainContainer">
        <Paper>
          <div className="pageContainer">
            <Container className="pt-3 BAVMainHeader" fluid>
              <Row>
                <Col >
                  <h5>Anlageberatungsprofile</h5>
                </Col>
                <Col  xs={4}>
                  <TextField
                    id="outlined-search"
                    label=""
                    variant="outlined"
                    size="small"
                    InputProps={searchFieldProps}
                    onChange={(e) => {
                      setSearchCriteria(e.target.value);
                    }}
                    value={searchCriteria}
                  />
                  {searchButton}
                </Col>
                <Col>
                  <FormControl sx={{ width: 200 }}>
                    <InputLabel
                      sx={{ fontSize: "0.750rem" }}
                      id="advisor_label"
                    >
                      Berater/in
                    </InputLabel>
                    <Select
                      labelId="advisor_label"
                      id="advisor"
                      value={selectedAdvisor}
                      onChange={(e) => setSelectedAdvisor(e.target.value!=null?e.target.value:'')}
                      sx={{ fontSize: "0.750rem" }}
                      size="small"
                    >
                      <MenuItem sx={{ fontSize: "0.750rem" }} key="">
                        Keine(r)
                      </MenuItem>
                      {advisordata.map((advisor) => (
                        <MenuItem
                          sx={{ fontSize: "0.750rem" }}
                          key={advisor.kdLnr}
                          value={advisor.benutzer}
                        >
                          {advisor.benutzer}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Col>

                <Col><FormControlLabel control={<Switch defaultChecked size="small" onChange={handleSwitchActive}/>} label="Aktive" /></Col>

                <Col >
                  <CustomerSearchDialog />
                </Col>
              </Row>
            </Container>

            <Container className="pt-3" fluid>
              <DataGrid
                className="BAVMainTable"
                getRowId={(row) => row.customerId}
                disableColumnMenu={true}
                loading={loading}
                localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                onRowDoubleClick={handleRowDoubleClick}
                rows={kundendaten}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 15 },
                    },
                    columns: {
                        columnVisibilityModel: {
                            kundenHauptTypCode: false
                        }
                    }
                }}
                pageSizeOptions={[15]}
                rowHeight={40}
              />
            </Container>
          </div>
        </Paper>
          </Container>

          <Snackbar
              open={notification.open}
              autoHideDuration={6000}
              onClose={() =>
                  setNotification({ ...notification, open: false })
              }
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
              <Alert
                  severity={notification.severity}
                  onClose={() =>
                      setNotification({ ...notification, open: false })
                  }
                  variant="filled"
              >
                  {notification.message}
              </Alert>
          </Snackbar>

    </>
  );
}
